<form #defaultForm="ngForm" (submit)="submitForm(defaultForm)" ngNativeValidate>
  <div class="row">
    <div
      *ngFor="let field of formFields; let i = index"
      class="my-3"
      [ngClass]="{ 'col-md-12': !field.size, 'col-md-6': field.size === 1, 'col-md-4': field.size === 2, 'col-md-3': field.size === 3 }"
    >
      <label *ngIf="field.hasLabel" [attr.for]="field.name" class="form-label fw-bold my-1">{{ field.labelName }}</label>

      <div [ngSwitch]="field.type">
        <div *ngSwitchCase="'text'" class="input-group">
          <input
            [readOnly]="field.disabled"
            [ngClass]="{ 'border-end-0': field.isInputGroup }"
            [attr.autocomplete]="field.autocomplete"
            [attr.inputmode]="field.inputMode"
            [id]="field.name"
            [attr.placeholder]="field.placeholder"
            [attr.required]="field.required"
            [attr.type]="field.type"
            [attr.max]="field.maxLength"
            [attr.min]="field.minLength"
            [attr.maxlength]="field.maxLength"
            [attr.minlength]="field.minLength"
            [attr.pattern]="field.pattern"
            [name]="field.name"
            [(ngModel)]="field.value"
            class="form-control scalped-border rounded-pill p-3"
          />
          <span
            *ngIf="field.isInputGroup"
            (click)="inputGroupAction(field)"
            class="input-group-text cursor-pointer m-0 border-0 bg-blend position-absolute password-visibility-button"
            id="basic-addon2"
          >
            {{ field.inputGroupText | titlecase }}
          </span>
        </div>

        <div *ngSwitchCase="'textarea'">
          <textarea
            [readOnly]="field.disabled"
            [ngClass]="{ 'border-end-0': field.isInputGroup }"
            [attr.autocomplete]="field.autocomplete"
            [attr.inputmode]="field.inputMode"
            [id]="field.name"
            [attr.placeholder]="field.placeholder"
            [attr.required]="field.required"
            [attr.type]="field.type"
            [attr.max]="field.maxLength"
            [attr.min]="field.minLength"
            [attr.maxlength]="field.maxLength"
            [attr.minlength]="field.minLength"
            [attr.pattern]="field.pattern"
            [name]="field.name"
            [(ngModel)]="field.value"
            class="form-control scalped-border rounded-pill p-3"
          ></textarea>
        </div>

        <div *ngSwitchCase="'date'" class="input-group">
          <input
            type="text"
            [name]="field.name"
            class="form-control"
            [(ngModel)]="field.value"
            (click)="i.open()"
            (keydown)="i.open()"
            [matDatepicker]="i"
            [attr.placeholder]="field.placeholder"
            aria-label="Start Date"
            aria-describedby="basic-addon1"
          />
          <mat-datepicker #i></mat-datepicker>
          <div (click)="i.open()" class="input-group-append cursor-pointer ml-1">
            <span class="input-group-text bg-white-prepend border-0" id="basic-addon1">
              <i style="top: 0" class="fas fa-calendar font-weight-bold"></i>
            </span>
          </div>
        </div>

        <div *ngSwitchCase="'select'" class="input-group">
          <label *ngIf="field.hasLabel" [attr.for]="field.name" class="form-label">{{ field.labelName }}</label>
          <select
            [name]="field.name"
            class="form-select form-control scalped-border rounded-pill"
            [attr.aria-label]="field.name"
            [(ngModel)]="field.value"
          >
            <option value="" selected>{{ field.placeholder }}</option>
            <option *ngFor="let option of field.options" [value]="option.value">{{ option.name }}</option>
          </select>
        </div>

        <div *ngSwitchCase="'file'" class="input-group">
          <button
            type="button"
            (click)="fileInput.click()"
            class="btn btn-upload scalped-border rounded-pill p-3 text-dark form-control text-start"
          >
            <i class="fa fa-paperclip mx-2"></i>
            {{ field.text }}
          </button>
          <input
            [attr.required]="field.required"
            [name]="field.name"
            ngModel
            (change)="handleUpload($event.target)"
            type="file"
            #fileInput
            hidden
            [attr.multiple]="field.multiple"
          />
        </div>

        <div *ngSwitchCase="'tel'" class="input-group">
          <input
            [readOnly]="field.disabled"
            [ngClass]="{ 'border-end-0': field.isInputGroup }"
            [attr.autocomplete]="field.autocomplete"
            [attr.inputmode]="field.inputMode"
            [id]="field.name"
            [attr.placeholder]="field.placeholder"
            [attr.required]="field.required"
            [attr.type]="field.type"
            [attr.max]="field.max"
            [attr.min]="field.min"
            [attr.maxlength]="field.maxLength"
            [attr.minlength]="field.minLength"
            pattern="{{ field.pattern }}"
            [name]="field.name"
            [(ngModel)]="field.value"
            class="form-control scalped-border rounded-pill p-3"
          />
          <span
            *ngIf="field.isInputGroup"
            (click)="inputGroupAction(field)"
            class="input-group-text cursor-pointer border-start-0 bg-blend"
            id="basic-addon7"
          >
            {{ field.inputGroupText }}
          </span>
        </div>

        <div *ngSwitchCase="'number'" class="input-group">
          <input
            [readOnly]="field.disabled"
            [ngClass]="{ 'border-end-0': field.isInputGroup }"
            [attr.autocomplete]="field.autocomplete"
            [attr.inputmode]="field.inputMode"
            [id]="field.name"
            [attr.placeholder]="field.placeholder"
            [attr.required]="field.required"
            [attr.type]="field.type"
            [attr.max]="field.max"
            [attr.min]="field.min"
            [attr.maxlength]="field.maxLength"
            [attr.minlength]="field.minLength"
            pattern="{{ field.pattern }}"
            [name]="field.name"
            [(ngModel)]="field.value"
            class="form-control scalped-border rounded-pill p-3"
          />
          <span
            *ngIf="field.isInputGroup"
            (click)="inputGroupAction(field)"
            class="input-group-text cursor-pointer border-start-0 bg-blend"
            id="basic-addon8"
          >
            {{ field.inputGroupText }}
          </span>
        </div>

        <div *ngSwitchCase="'month'" class="input-group">
          <input
            [readOnly]="field.disabled"
            [ngClass]="{ 'border-end-0': field.isInputGroup }"
            [attr.autocomplete]="field.autocomplete"
            [attr.inputmode]="field.inputMode"
            [id]="field.name"
            [attr.placeholder]="field.placeholder"
            [attr.required]="field.required"
            [attr.type]="field.type"
            [attr.max]="field.maxLength"
            [attr.min]="field.minLength"
            [attr.maxlength]="field.maxLength"
            [attr.minlength]="field.minLength"
            pattern="{{ field.pattern }}"
            [name]="field.name"
            [(ngModel)]="field.value"
            class="form-control scalped-border rounded-pill p-3"
          />
          <span
            *ngIf="field.isInputGroup"
            (click)="inputGroupAction(field)"
            class="input-group-text cursor-pointer border-start-0 bg-blend"
            id="basic-addon6"
          >
            {{ field.inputGroupText }}
          </span>
        </div>

        <div *ngSwitchCase="'password'" class="input-group">
          <input
            [readOnly]="field.disabled"
            [ngClass]="{ 'border-end-0': field.isInputGroup }"
            [attr.autocomplete]="field.autocomplete"
            [attr.inputmode]="field.inputMode"
            [id]="field.name"
            [attr.placeholder]="field.placeholder"
            [attr.required]="field.required"
            [attr.type]="field.type"
            [attr.max]="field.maxLength"
            [attr.min]="field.minLength"
            [attr.maxlength]="field.maxLength"
            [attr.minlength]="field.minLength"
            pattern="{{ field.pattern }}"
            [name]="field.name"
            [(ngModel)]="field.value"
            class="form-control scalped-border rounded-pill p-3"
          />
          <span
            *ngIf="field.isInputGroup"
            (click)="inputGroupAction(field)"
            class="input-group-text cursor-pointer m-0 border-0 bg-blend position-absolute password-visibility-button"
            id="basic-addon3"
          >
            {{ field.inputGroupText | titlecase }}
          </span>
        </div>

        <div *ngSwitchCase="'email'" class="input-group">
          <input
            [readOnly]="field.disabled"
            [ngClass]="{ 'border-end-0': field.isInputGroup }"
            [attr.autocomplete]="field.autocomplete"
            [attr.inputmode]="field.inputMode"
            [id]="field.name"
            [attr.placeholder]="field.placeholder"
            [attr.required]="field.required"
            [attr.type]="field.type"
            [attr.max]="field.maxLength"
            [attr.min]="field.minLength"
            [attr.maxlength]="field.maxLength"
            [attr.minlength]="field.minLength"
            pattern="{{ field.pattern }}"
            [name]="field.name"
            [(ngModel)]="field.value"
            class="form-control scalped-border rounded-pill p-3"
          />
          <span
            *ngIf="field.isInputGroup"
            (click)="inputGroupAction(field)"
            class="input-group-text cursor-pointer border-start-0 bg-blend"
            id="basic-addon4"
          >
            {{ field.inputGroupText }}
          </span>
        </div>

        <div *ngSwitchCase="'radio'" class="">
          <div *ngFor="let option of field.options" class="form-check form-check-inline">
            <input
              [readOnly]="field.disabled"
              class="form-check-input"
              type="radio"
              [name]="field.name"
              [id]="option.name"
              [value]="option.value"
              [(ngModel)]="field.value"
            />
            <label class="form-check-label" [attr.for]="option.name">{{ option.name }}</label>
          </div>
        </div>

        <span *ngIf="field.hasSubText" class="text-start small"> {{ field.subText }}</span>

        <!--              <span class="text-danger" *ngIf="defaultForm.getControl(field.name).dirty || defaultForm.getControl(field.name).invalid || defaultForm.getControl(field.name).touched"> {{field.name}} is required </span>-->
        <!--      <span class="text-danger" *ngIf="defaultForm.getControl(field).hasError('minLength') && defaultForm.getControl(field.name).dirty "> {{field.name}} has a minimum length of {{field.minLength}} </span>-->
      </div>
    </div>
  </div>
  <div class="form-group">
    <div>
      <app-button-solid [buttonDetails]="buttonDetails"></app-button-solid>
    </div>
  </div>
</form>
